
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useLanguage } from '../contexts/LanguageContext';

interface NewConversationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const NewConversationDialog = ({ open, onOpenChange, onConfirm }: NewConversationDialogProps) => {
  const { t } = useLanguage();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md bg-background d2cbot-bot_border text-foreground rounded-lg shadow-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-foreground">{t('dialog.new.conversation.title')}</AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground">
            {t('dialog.new.conversation.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-col space-y-2 sm:space-y-0 sm:flex-row sm:space-x-3">
          <AlertDialogCancel className="w-full sm:w-auto order-2 sm:order-1 !no-underline hover:!no-underline focus:!no-underline active:!no-underline [&]:!no-underline [&:hover]:!no-underline [&:focus]:!no-underline [&:active]:!no-underline">
            {t('dialog.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="w-full sm:w-auto order-1 sm:order-2 !no-underline hover:!no-underline focus:!no-underline active:!no-underline [&]:!no-underline [&:hover]:!no-underline [&:focus]:!no-underline [&:active]:!no-underline"
          >
            {t('dialog.new.conversation.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default NewConversationDialog;
